import React, { Suspense, FunctionComponent } from 'react';
import { Loader } from '@/components/core/Loader';

export const AsyncComponent: FunctionComponent = ({ children }) => (
  <Suspense fallback={<Loader active />}>{children}</Suspense>
);

export default AsyncComponent;
